import { cx } from 'cva';
import { type FunctionComponent, type ReactNode } from 'react';
import { useScripture } from '../../hooks/useScripture';
import { MediShareLogoIcon } from '../MediShareLogo/MediShareLogoIcon';
import styles from './LinearLoading.module.css';
import { LinearProgressBar } from './LinearProgressBar/LinearProgressBar';

export type LinearLoadingProps = {
  className?: string;
  description?: string;
  showBibleVerse?: boolean;
  showLogo?: boolean;
  title?: ReactNode;
};

export const LinearLoading: FunctionComponent<LinearLoadingProps> = ({
  className,
  description,
  showBibleVerse = false,
  showLogo = false,
  title,
}) => {
  const scripture = useScripture();
  return (
    <div className={cx(styles.root, className)}>
      {showLogo && <MediShareLogoIcon className={styles.logo} />}
      {title && <h2 className={styles.title}>{title}</h2>}
      {description && <div className={styles.description}>{description}</div>}

      <LinearProgressBar />
      {showBibleVerse && (
        <div className={cx(styles.scripture)}>
          <p>{scripture.text}</p>
          <div className={styles.scriptureReference}>{scripture.reference}</div>
        </div>
      )}
    </div>
  );
};
